import { OAuthErrorEvent } from 'angular-oauth2-oidc';
import { OAuthErrorFilterService } from '@abp/ng.oauth';

export const IMPERSONATION_OAUTH_ERROR_FILTER_ID = 'ca-impersonation-invalid-request';

export function registerImpersonationOAuthErrorFilter(
  oAuthErrorFilterService: OAuthErrorFilterService,
): void {
  if (oAuthErrorFilterService.get(IMPERSONATION_OAUTH_ERROR_FILTER_ID)) {
    return;
  }

  oAuthErrorFilterService.add({
    id: IMPERSONATION_OAUTH_ERROR_FILTER_ID,
    executable: true,
    execute: (event: OAuthErrorEvent): boolean => {
      const reason: any = event?.reason;
      const requestUrl: string = reason?.url ?? '';
      const oauthError: string = reason?.error?.error ?? '';

      return requestUrl.indexOf('/connect/token') > -1 && oauthError === 'invalid_request';
    },
  });
}
